// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { InstrumentSecurityControlService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/InstrumentSecurityControl';
import { InstrumentConfiguration } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Configuration/Instrument';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useAddSecurityLockInstrumentConfiguration: () => UseMutationResult<
  void,
  string,
  {
    instrumentSecurityControlServiceCid: ContractId<InstrumentSecurityControlService>;
    instrumentConfigurationCid: ContractId<InstrumentConfiguration>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['addSecurityLockInstrumentConfiguration', ledgerApi],
    mutationFn: async ({ instrumentSecurityControlServiceCid, instrumentConfigurationCid }) => {
      return ledgerApi.addSecurityLockOnRegistryInstrumentConfiguration(
        instrumentSecurityControlServiceCid,
        instrumentConfigurationCid,
      );
    },
    retry: false,
  });
};

export default useAddSecurityLockInstrumentConfiguration;
